import { observable, action } from 'mobx';

import { cloneDeep, at, merge } from 'lodash';

import en from '../translations/en.json';
import it from '../translations/it.json';
import de from '../translations/de.json';

const AVAILABLES = { it, en, de };

class TranslationsStore {
  @observable
  translation = it;

  translate(key) {
    if (this.translation) {
      try {
        return at(this.translation, key)[0] || key;
      } catch (e) {
        console.error(`${key} not found`);
        return key;
      }
    }
  }

  @action
  setLocale(locale) {
    this.translation = merge({}, cloneDeep(it), AVAILABLES[locale]);
  }
}

export default new TranslationsStore();
